export default __webpack_public_path__ + "static/media/alert.664fc189.svg";